import React from 'react';

interface MeetingManagerIconProps {
  isActive?: boolean;
  className?: string;
}

const MeetingManagerIcon: React.FC<MeetingManagerIconProps> = ({ isActive = false, className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      className={`${className} mr-2`}
      width="18" 
      height="18" 
      viewBox="0 0 24 24" 
      fill="none" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    >
      {/* Calendar with checkmark */}
      <rect 
        width="18" 
        height="18" 
        x="3" 
        y="4" 
        rx="2" 
        ry="2"
        stroke={isActive ? "#4F46E5" : "#4B5563"}
        fill="none" 
      />
      <line x1="16" x2="16" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
      <line x1="8" x2="8" y1="2" y2="6" stroke={isActive ? "#4F46E5" : "#4B5563"} />
      <line x1="3" x2="21" y1="10" y2="10" stroke={isActive ? "#4F46E5" : "#4B5563"} />
      <path d="M9 16l2 2 4-4" stroke={isActive ? "#4F46E5" : "#4B5563"} />
    </svg>
  );
};

export default MeetingManagerIcon;
